import { AuthoringUtils as n } from "@adobe/aem-spa-page-model-manager";
import { useMemo as s, useLayoutEffect as m } from "react";
import { u as P } from "./useViewPortProps-0c0b5cc6.js";
import "@ucl/react-library/useMediaQuery";
import "@ucl/shared-component-foundations/foundations";
const E = (t, o) => {
  const r = s(() => n.isInEditor(), []);
  m(() => {
    var i;
    const e = (i = t == null ? void 0 : t.current) == null ? void 0 : i.parentElement;
    !r || !e || !o || Object.assign(e.style, o);
  }, [
    r,
    o,
    t
  ]);
};
export {
  E as useEditableParentStyle,
  P as useViewPortProps
};
